import React from 'react';
import HallazgosTable from 'components/admin/Hallazgos/HallazgosTable';
import SectionHint from 'components/ciclo/SectionHint';

function HallazgosPage({ id }) {
  return (
    <div className="space-y-4">
      <SectionHint
        id="hallazgos-cliente"
        message="Hallazgos de este cliente"
        description="Detectados en sus mantenciones. Los que están en etapa Detectado se pueden presupuestar directo desde acá."
      />
      <HallazgosTable clienteFijo={Number(id)} />
    </div>
  );
}

export default HallazgosPage;
